import { Box, Divider, Flex, FormControl, FormLabel, Input, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text, useDisclosure, } from "@chakra-ui/react";
import MyDiv from "./cloneJobOpening.style";
import { useEffect, useState } from "react";
import { MultiSelectMenu } from "../../../../../components/MultiSelectMenu/MultiSelectMenu";
import { AlertCard, CustomButton, CustomToast } from "../../../../../components";
import Lottie from "lottie-react";
import SuccessAnimation from "../../../../../assets/lottie/Success.json";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { useFetch } from "../../../../../hooks/useFetch";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IJobOpening, emptyJobOpening, schema, JobOpeningCardProps, urgencyLevelOptions } from "./modal";
import { Dropdown } from "../../../../../components/DropDown/DropDown";
import { HrlenseInput } from "../../../../../components/Input/Input";
import { PayrollOption } from "../../../../Employees/AddNewEmployee/components/Employment&Experience/model";


const CloneJobOpening: React.FC<JobOpeningCardProps> = ({ jobData, handleDrawer, loadJobOpening }) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [selectedSkills, setSelectedSkills] = useState<any[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [alertOpen, setAlertOpen] = useState(false);
  const [payrollCompanyOptions, setPayrollCompanyOptions] = useState<PayrollOption[]>([]);
  const [branchOptions, setBranchOptions] = useState<any[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<any[]>([]);
  const [jobProfileOptions, setJobProfileOptions] = useState<any[]>([]);
  const [employementType, setEmploymentType] = useState<any[]>([]);
  const [jobSummary, setJobSummary] = useState<string>("");
  const [workMode, setWorkMode] = useState<any[]>([]);
  const [jobSkills, setJobSkills] = useState<any[]>([]);
  const [jobPostingLoading, setJobPostingLoading] = useState(false);

  const { handleSubmit, control, formState: { errors }, reset, watch } = useForm<IJobOpening>({
    resolver: yupResolver(schema),
    defaultValues: emptyJobOpening,
    mode: "onBlur",
  });

  useEffect(() => {
    if (jobData) {
      const formattedData = {
        ...jobData,
        job_Opening_Date: jobData.job_Opening_Date ? jobData.job_Opening_Date.replace(/\//g, "-") : "",
        job_Closing_Date: jobData.job_Closing_Date ? jobData.job_Closing_Date.replace(/\//g, "-") : "",
        expected_Date_Of_Joining: jobData.expected_Date_Of_Joining ? jobData.expected_Date_Of_Joining.replace(/\//g, "-") : "",
      };

      reset(formattedData);

      if (jobData.skill) {
        const skillsArray = jobData.skill.split(",").map((s: string) => parseInt(s, 10));
        setSelectedSkills(skillsArray);
      } else {
        setSelectedSkills([]);
      }

      setJobSummary(jobData.jd_Description || "");

      if (jobData.payroll_Company_Id) {
        loadBranchOptions(jobData.payroll_Company_Id);
      }
      if (jobData.department_Id) {
        loadJobProfile(jobData.department_Id);
      }
      if (jobData.department_Id && jobData.job_Profile) {
        loadJobSkills(jobData.department_Id, jobData.job_Profile);
      }
    }
  }, [jobData]);

  const handleConfirmStatusChange = () => {
    setAlertOpen(false);

    handleSubmit(onSubmit)();
  };

  const onSubmit = async (data: IJobOpening) => {
    try {
      const formatDateOnly = (dateValue: any) => {
        if (!dateValue) return "";
        const d = new Date(dateValue);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };
      
      const payload = {
        ...data,
        job_Opening_Date: formatDateOnly(data.job_Opening_Date),
        job_Closing_Date: formatDateOnly(data.job_Closing_Date),
        expected_Date_Of_Joining: formatDateOnly(data.expected_Date_Of_Joining),
        skills: selectedSkills.map((s: any) =>
          typeof s === "object" ? s.id : s
        ),
        jd_Description: jobSummary,
      };
      setJobPostingLoading(true);

      const res = await fetchApi("JobOpening/JobPosting", "POST", payload, "", "Job Opening Posted Successfully");

      if (res) {
        setAlertOpen(false);
        onOpen();               //Show success modal
        setTimeout(() => {
          onClose();
        }, 1500);

        setTimeout(() => {
          handleDrawer(false);
        }, 1600);
        setTimeout(() => onClose(), 1000);

        reset();
        setSelectedSkills([]);
        setJobSummary("");
        loadJobOpening();
        setJobPostingLoading(false);
      }
      setJobPostingLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const ClearDrawer = () => {
    reset(emptyJobOpening);
    setSelectedSkills([]);
    setJobSummary("");
  };

  const PayrollCompany = async () => {
    const response = await fetchApi("DropDown/payrollCompany", "GET", null, "", "");
    if (response) setPayrollCompanyOptions(response);
  };
  const loadBranchOptions = async (payrollCompanyId: number) => {
    const res = await fetchApi("DropDown/payRollBranches", "GET", null, `payroll_Id=${payrollCompanyId}`, "");
    if (res) setBranchOptions(res);
  };

  const loadDepartmentOptions = async () => {
    const res = await fetchApi("DropDown/department", "GET", null, "", "");
    if (res) setDepartmentOptions(res);
  };

  const loadJobProfile = async (department_Id?: number) => {
    const res = await fetchApi("DropDown/getJobProfile", "GET", null, `department_Id=${department_Id}`, "");
    if (res) setJobProfileOptions(res);
  };

  const LoadEmploymentType = async () => {
    const res = await fetchApi("RecruitmentMaster/employmentType", "GET", null, "");
    if (res) setEmploymentType(res);
  };

  const LoadWorkMode = async () => {
    const res = await fetchApi("RecruitmentMaster/WorkMood", "GET", null, "");
    if (res) setWorkMode(res);
  };

  const loadJobSkills = async (department_Id?: number, job_Profile?: number) => {
    const query = `department_Id=${department_Id}&job_Profile=${job_Profile}`
    const res = await fetchApi("RecruitmentDropDown/JobSkills", "GET", null, query, "");
    if (res) setJobSkills(res);
  }

  useEffect(() => {
    PayrollCompany();
    loadDepartmentOptions();
    LoadEmploymentType();
    LoadWorkMode();
  }, []);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "payroll_Company_Id") {
        if (value.payroll_Company_Id) {
          loadBranchOptions(value.payroll_Company_Id)
        } else {
          loadBranchOptions(0)
        }
      }
      if (name === "department_Id") {
        if (value.department_Id) {
          loadJobProfile(Number(value.department_Id))
        } else {
          loadJobProfile(0)
        }
        setSelectedSkills([]);
        setJobSkills([]);
      }
      if (name === "job_Profile") {
        setSelectedSkills([]);
        setJobSkills([]);
      }
      if ((name === "department_Id" || name === "job_Profile") && value.department_Id && value.job_Profile) {
        loadJobSkills(Number(value.department_Id), Number(value.job_Profile));
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);


  return (
    <MyDiv>
      <Box py={2} as="form" onSubmit={handleSubmit(onSubmit)}>
        <Text className="font-poppins text_medium text_lg">Basic Information</Text>
        <Flex gap={8} mt={2}>
          <Dropdown isRequired name="payroll_Company_Id" label="Payroll Company" control={control} errors={errors} options={payrollCompanyOptions} valueKey="id" labelKey="payroll_Company_Name" />
          <Dropdown isRequired name="branch_Id" label="Branch" control={control} errors={errors} options={branchOptions} valueKey="branch_ID" labelKey="branchName" />
        </Flex>
        <Flex gap={8} mt={2}>
          <Dropdown isRequired name="department_Id" label="Department" control={control} errors={errors} options={departmentOptions} valueKey="id" labelKey="departmentName" />
          <Dropdown isRequired name="job_Profile" label="Job Title" control={control} errors={errors} options={jobProfileOptions} valueKey="id" labelKey="job_Profile" />
        </Flex>

        <Flex gap={8} mt={2}>
          <HrlenseInput isRequired name="number_Of_Openings" control={control} errors={errors} label="Number of openings" type="number" placeholder="Enter Number of Openings" />
          <Dropdown isRequired name="employement_Type_Id" label="Employement Type" control={control} errors={errors} options={employementType} valueKey="id" labelKey="selection_Term" />
        </Flex>

        <Flex gap={8} mt={2}>
          <HrlenseInput isRequired name="job_Opening_Date" control={control} errors={errors} label="Job Opening Date" type="date" placeholder="Select Job Opening Date" min={new Date().toISOString().split("T")[0]} />
          <HrlenseInput isRequired name="job_Closing_Date" control={control} errors={errors} label="Job Closing Date" type="date" placeholder="Select Job Closing Date" min={new Date().toISOString().split("T")[0]} />
        </Flex>

        <Flex gap={8} mt={2}>
          <HrlenseInput isRequired name="salaryRange" control={control} errors={errors} label="Salary Range" type="number" placeholder="Enter Min/Max Salary" />
          <HrlenseInput isRequired name="expected_Date_Of_Joining" control={control} errors={errors} label="Expected Date of Joining" type="date" placeholder="Select Expected Date of Joining" min={new Date().toISOString().split("T")[0]} />
        </Flex>

        <Flex gap={8} mt={2}>
          <Dropdown isRequired name="urgency_Level" label="Urgency Level" control={control} errors={errors} options={urgencyLevelOptions} valueKey="id" labelKey="label" />
          <Dropdown isRequired name="work_Mood" label="Work Mode" control={control} errors={errors} options={workMode} valueKey="id" labelKey="work_Mood" />
        </Flex>

        <Flex gap={8} mt={2}>
          <FormControl isRequired>
            <MultiSelectMenu
              label="Required Skills"
              options={jobSkills}
              selectedValues={selectedSkills}
              setSelectedValues={setSelectedSkills}
              labelKey="skill"
              valueKey="id"
              placeholder="Select Skills"
            />
          </FormControl>
        </Flex>

        <Text className="font-poppins text_medium text_lg"> Additional Details</Text>
        <Flex gap={8} mt={2} mb={3}>
          <Controller
            name="experience_From"
            control={control}
            render={({ field }) => (
              <FormControl isRequired isInvalid={!!errors.experience_From}>
                <FormLabel>Experience (in years) Min</FormLabel>
                <Input
                  {...field}
                  type="number"
                  placeholder="0 year"
                  value={field.value ?? ""}
                  onChange={(e) => {
                    let value = e.target.value.replace(/^0+(?=\d)/, "");
                    let cappedValue = Math.min(Number(value || 0), 50);
                    field.onChange(value === "" ? "" : cappedValue);
                  }}
                />
                {errors.experience_From && (
                  <Text color="red.500">{errors.experience_From.message}</Text>
                )}
              </FormControl>
            )}
          />

          <Controller
            name="experience_To"
            control={control}
            render={({ field }) => (
              <FormControl isRequired isInvalid={!!errors.experience_To}>
                <FormLabel>Experience (in years) Max</FormLabel>
                <Input
                  {...field}
                  type="number"
                  placeholder="0 year"
                  value={field.value ?? ""}
                  onChange={(e) => {
                    let value = e.target.value.replace(/^0+(?=\d)/, "");
                    let cappedValue = Math.min(Number(value || 0), 50);
                    field.onChange(value === "" ? "" : cappedValue);
                  }}
                />
                {errors.experience_To && (
                  <Text color="red.500">{errors.experience_To.message}</Text>
                )}
              </FormControl>
            )}
          />
        </Flex>

        <Text className="font-poppins text_medium text_lg">Job Description</Text>
        <FormControl mb={3} isRequired mt={2}>
          <FormLabel className="font-poppins text_regular text_md">Job Summary</FormLabel>
          <Controller
            name="jobSummary"
            control={control}
            render={({ field }) => (
              <SunEditor
                height="200px"
                placeholder="Enter Job Summary"
                setOptions={{
                  buttonList: [
                    ["undo", "redo"],
                    ["bold", "italic", "underline", "strike"],
                    ["list", "align", "fontSize", "formatBlock"],
                    ["link", "image", "video"],
                    ["removeFormat"]
                  ]
                }}
                setContents={field.value || ""}
                onChange={field.onChange}
              />
            )}
          />
          {errors.jobSummary && (
            <Text color="red.500" fontSize="sm">{errors.jobSummary.message}</Text>
          )}
        </FormControl>

        <Box>
          <Flex gap={3} justify="flex-end">
            <CustomButton title="Clear" onClick={ClearDrawer} className=" abc font-poppins text_sm text_medium" />
            <CustomButton title="Publish New Job" className="btn abc font-poppins text_sm text_medium" onClick={() => setAlertOpen(true)} isLoading={jobPostingLoading} />
          </Flex>
        </Box>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
        <ModalOverlay />
        <ModalContent borderRadius="lg" p={2}>
          <ModalHeader textAlign="center">Publish Job</ModalHeader>
          <Divider />
          <ModalBody>
            <Box textAlign="center" p={1}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Lottie animationData={SuccessAnimation} loop={false} style={{ height: 120 }} />
              </Box>
              <Text mt={2} className="font-poppins text_sm text_semibold" color="green.600" > {jobData ? "Update Successful" : "Publish Successful"}</Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertCard
        isOpen={alertOpen}
        onClose={() => setAlertOpen(false)}
        onConfirm={handleConfirmStatusChange}
        title="Publish Job"
        description="Are you sure you want to publish this new job?"
        confirmLabel="Confirm"
        cancelLabel="Cancel"
      />

    </MyDiv>
  );
};

export default CloneJobOpening;